import { GamePromotion } from '@/features/games/shared/types/game-data';

export function resolveViewerPromotion(
  promotion: GamePromotion | undefined,
  isMember: boolean,
): GamePromotion | undefined {
  if (!promotion) return undefined;
  if (promotion.percentage === 0 && !isMember) return undefined;
  return promotion;
}
